import rightImg from "images/rightimg.png";
import React, { FC } from "react";
import SectionFounder from "./SectionFounder";
import SectionStatistic from "./SectionStatistic";
import { useDocumentTitle } from "hooks/useDocumentTitle";
import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import SectionHero from "./SectionHero";
import SectionClientSay from "components/SectionClientSay/SectionClientSay";
import { globalJson } from "global/global_json";
import SectionHero2 from "./SectionHero2";
import AboutUsSection from "./AboutUsSection";
import SectionInfoBanner from "./SectionInfoBanner";
import CarRentalSteps from "components/Steps/Steps";

export interface PageAboutProps {
  className?: string;
}

const PageAbout: FC<PageAboutProps> = ({ className = "" }) => {
  useDocumentTitle("About || Car rental");
  return (
    <div
      className={`nc-PageAbout overflow-hidden relative ${className}`}
      data-nc-id="PageAbout"
    >
      <div className="container space-y-16 lg:space-y-28">

        <SectionHero
          rightImg={rightImg}
          heading="Welcome to Kings Car Rentals"
          btnText=""
          subHeading={globalJson?.about_us_para}
        />
      </div>
      <div className="container py-16   space-y-16 lg:space-y-28">
        <CarRentalSteps />
      </div>
      <div className="bg-[#595A5B]">
        <div className="relative py-16">
          <SectionClientSay uniqueClassName="PageAbout_" />
        </div>
      </div>
    </div>
  );
};

export default PageAbout;
